import { useTranslation } from "react-i18next";
import { Smartphone } from "lucide-react";
import { useSession } from "@/shared/auth/SessionContext";

export function OperatorDesktopBlockScreen() {
  const { t } = useTranslation("session");
  const { logout } = useSession();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="mx-auto max-w-md text-center space-y-6">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
          <Smartphone className="h-10 w-10 text-primary" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">
            {t("operatorBlock.title")}
          </h1>
          <p className="text-muted-foreground">
            {t("operatorBlock.description")}
          </p>
        </div>

        <p className="text-sm text-muted-foreground">
          {t("operatorBlock.explanation")}
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            type="button"
            disabled
            className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground opacity-60 cursor-not-allowed"
          >
            {t("operatorBlock.appStore")}
          </button>
          <button
            type="button"
            disabled
            className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground opacity-60 cursor-not-allowed"
          >
            {t("operatorBlock.googlePlay")}
          </button>
        </div>

        <button
          type="button"
          onClick={logout}
          className="text-sm text-primary underline-offset-4 hover:underline"
        >
          {t("operatorBlock.switchAccount")}
        </button>
      </div>
    </div>
  );
}
